import type { CSSProperties } from 'react'
import styles from './LoadingScreen.module.css'

/**
 * .screen의 opacity 트랜지션 지속 시간. LoadingScreen이 인라인 스타일로 CSS
 * 커스텀 프로퍼티(--loading-exit-duration)에 이 값을 그대로 채워 넣고, App은
 * 같은 상수로 언마운트 타이머를 재운다 — 값이 한 곳에만 있으므로 CSS와 타이머가
 * 어긋날 수 없다.
 */
export const LOADING_EXIT_MS = 600

export interface LoadingScreenProps {
  progress: number
  escapeAvailable: boolean
  onEnter: () => void
  /** true면 화면이 페이드아웃 중이다 — App이 LOADING_EXIT_MS 뒤에 언마운트한다. */
  exiting?: boolean
}

export function LoadingScreen({ progress, escapeAvailable, onEnter, exiting = false }: LoadingScreenProps) {
  const percent = Math.round(Math.min(1, Math.max(0, progress)) * 100)
  const screenStyle = { '--loading-exit-duration': `${LOADING_EXIT_MS}ms` } as CSSProperties
  return (
    <div
      className={exiting ? `${styles.screen} ${styles.exiting}` : styles.screen}
      style={screenStyle}
    >
      <div className={styles.title}>
        We&#39;re
        <br />
        Getting Married
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-label="청첩장 준비 중"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
      {escapeAvailable && (
        <button type="button" className={styles.escape} onClick={onEnter} disabled={exiting}>
          네트워크가 느려요 — 그냥 들어가기
        </button>
      )}
    </div>
  )
}
